<template>
  <a-card :loading="loading" v-if="tabbed">
    <div slot="title">
      <a-icon type="pic-center" />
      <span>&nbsp; {{ title }}</span>
    </div>
    <a-button icon="plus" type="primary" slot="extra" @click="handleCreate" v-if="!disabledCreateEditLink">
      Create
    </a-button>

    <a-tabs defaultActiveKey="list" type="card" @change="callbackTab">
      <a-tab-pane :tab="dataListTitle ? dataListTitle : 'Report List'" key="list">
        <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
          <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta>
              <a-row slot="title" type="flex" justify="space-between">
                <div class="m-display-flex flex-column">
                  <div v-if="item.cancelStatus && item.cancelStatus === 'Canceled'">
                    <status :status="'Cancelled'" />
                  </div>
                  <span>{{ item.title }}&nbsp;</span>
                </div>
                <Status :status="item.status" class="margin-remove" />
              </a-row>
              <div slot="description">
                <ul class="m-list-wrapper">
                  <li v-for="item in item.subdesc" :key="item" class="margin-remove">
                    {{ item }}
                  </li>

                  <li v-if="price">
                    <h3 class="margin-remove">
                      {{ formatCurrency(item.mata_uang, item.price) }}
                    </h3>
                  </li>
                  <li v-if="estimasi">
                    <a-divider class="margin-small" />
                    <h4 class="margin-remove m-text-align right m-text-sub">
                      Estimated Value
                    </h4>
                    <h3 class="margin-remove m-text-align right">
                      {{ formatCurrency(item.mata_uang, item.estimated_value) }}
                    </h3>
                  </li>
                  <li v-if="sisaSaldo">
                    <h4 class="margin-remove m-text-align right m-text-sub">
                      Sisa Saldo
                    </h4>
                    <h3 class="margin-remove m-text-align right">
                      {{ formatCurrency(item.mata_uang, item.sisa_saldo) }}
                    </h3>
                  </li>
                  <li v-if="rating">
                    <Rating :rating="item.rating_value" />
                  </li>
                </ul>
              </div>
            </a-list-item-meta>
            <template class="actions">
              <a-button-group ghost>
                <a-button type="primary">
                  <router-link :to="{
                    name: manifestLink,
                    params: { id: item.id, rabview: rab, type: item.type },
                  }">
                    <a-icon type="eye" />&nbsp;Manifest
                  </router-link>
                </a-button>
                <a-button v-if="
                  !disabledCreateEditLink &&
                  !disabledCreateEditLink &&
                  ((item.status === 'Revised' && item.cancelStatus == null) ||
                    (item.status !== 'Non Aktif' && route === 'keuangan'))
                ">
                  <router-link :to="{
                    name: editLink,
                    params: { id: item.id, type: 'revised' },
                  }">
                    <a-icon type="edit" />
                    <span>&nbsp;Edit Data</span>
                  </router-link>
                </a-button>
                <a-button v-if="
                  !disabledCreateEditLink &&
                  (item.status === 'Revised' ||
                    (item.status !== 'Non Aktif' && route === 'keuangan')) &&
                  (!item.cancelStatus ||
                    (item.cancelStatus &&
                      item.cancelStatus !== 'Canceled')) &&
                  allowcancel === true
                " @click="handleCancel(item)">
                  <router-link :to="{ name: '', params: { id: item.id } }">
                    <a-icon type="close-square" />&nbsp;
                    <span>Cancel</span>
                  </router-link>
                </a-button>
                <a-button v-if="rab" @click="handleRab(item)">
                  <span>RAB</span>
                </a-button>
              </a-button-group>
            </template>
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <a-tab-pane key="draft">
        <span slot="tab">
          {{ dataDraftTitle ? dataDraftTitle : 'Draft List' }}
          <a-badge class="m-badge m-badge-small" :count="draftList.length" :numberStyle="{ backgroundColor: 'red' }"
            v-if="draftList && draftList.length > 0">
          </a-badge>
        </span>
        <a-list itemLayout="vertical" :dataSource="draftList" :pagination="pagination">
          <Empty v-if="draftList ? draftList.length <= 0 : draftList" />
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta>
              <a-row slot="title" type="flex" justify="space-between">
                <a href="#">{{ item.title }}</a>
                <Status :status="item.status" class="margin-remove" />
              </a-row>
              <div slot="description">
                <ul class="m-list-wrapper">
                  <li v-for="item in item.subdesc" :key="item" class="margin-remove">
                    {{ item }}
                  </li>
                  <li v-if="price">
                    <h3 class="margin-remove">
                      {{ formatCurrency(item.mata_uang, item.price) }}
                    </h3>
                  </li>
                  <li v-if="estimasi">
                    <a-divider class="margin-small" />
                    <h4 class="margin-remove m-text-align right m-text-sub">
                      Estimated Value
                    </h4>
                    <h3 class="margin-remove m-text-align right">
                      {{ formatCurrency(item.mata_uang, item.estimated_value) }}
                    </h3>
                    <h3 class="margin-remove m-text-align right">
                      {{ formatCurrency(item.mata_uang, item.estimated_value) }}
                    </h3>
                  </li>
                  <li v-if="rating">
                    <Rating :rating="item.rating_value" />
                  </li>
                </ul>
              </div>
            </a-list-item-meta>
            <template class="actions">
              <a-button-group ghost class="margin-top">
                <a-button type="default">
                  <router-link :to="{
                    name: draftEditLink,
                    params: { id: item.id, type: 'draft' },
                  }">
                    <a-icon type="edit" />&nbsp;Edit Data
                  </router-link>
                </a-button>
              </a-button-group>
            </template>
          </a-list-item>
        </a-list>
      </a-tab-pane>
    </a-tabs>
  </a-card>
  <a-card v-else-if="tabbedTransactional" :class="loading ? '' : 'm-card-list'" :loading="loading">
    <div slot="title">
        <a-icon type="pic-center" />
        <span>&nbsp; {{ title }}</span>
    </div>
    <div slot="extra">
      <slot name="titleAdvanced"></slot>
      <a-button type="primary" slot="extra" @click="handleCreate" icon="plus" v-if="!notCreate && !disabledCreateEditLink">
        Create
      </a-button>
    </div>    
    <a-tabs defaultActiveKey="list" type="card" @change="callbackTab">
      <a-tab-pane v-if="dataList" :tab="dataListTitle ? dataListTitle : 'Report List'" key="list">
        <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
          <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
          <a-list-item :class="item.unread ? '' : 'read'" slot="renderItem" slot-scope="item">
            <router-link :to="{
              name: manifestLink,
              params: {
                id: item.id,
                user_pembuat: item.user_pembuat,
                rabview: rab,
                tipe: item.tipe
              },
            }">
              <a-list-item-meta>
                <div slot="description" class="m-display-flex space-between">
                  <div :style="getScreen ? 'width:100%' : 'width:50%'">
                    <div>
                      <span v-if="
                        item.delivered_po_wo &&
                        item.delivered_po_wo.toLowerCase() === 'refunded'
                      ">
                        <status :status="'Refunded'" />
                      </span>
                      <span v-if="
                        item.cancelStatus && item.cancelStatus === 'Canceled'
                      ">
                        <status :status="'Cancelled'" />
                      </span>
                      <span v-if="
                        item.delivered_po_wo &&
                        item.delivered_po_wo.toLowerCase() === 'done'
                      ">
                        <status :status="'Received'" />
                      </span>
                      <span v-if="
                        item.closed_po_wo &&
                        item.closed_po_wo.toLowerCase() === '1'
                      ">
                        <status :status="'CLOSED'" />
                      </span>
                    </div>
                    <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                      {{ item.title }}
                    </h4>
                    <span class="color-black" v-else>{{ item.title }}</span>
                    <span class="m-display-block">{{ item.subtitle }}</span>
                    <ul class="m-list-wrapper">
                      <li v-for="(items, index) in item.subdesc" :key="index" class="margin-remove">
                        <span v-if="!Array.isArray(items)">{{ items }}</span>
                        <div v-else v-for="(subItem, index) in items" :key="index">
                          <div class="m-display-flex flex-row space-between">
                            <h4 v-if="item.unread" class="margin-remove">
                              {{ subItem.label }}
                            </h4>
                            <span v-else class="m-display-block margin-remove">{{ subItem.label }}</span>
                            {{ subItem.value }}
                          </div>
                        </div>
                      </li>
                      <li v-if="rating">
                        <Rating :rating="item.rating_value" />
                      </li>
                    </ul>
                    <template class="actions" v-if="
                      (!disabledCreateEditLink &&
                        item.status == 'Revised' &&
                        !item.hideedit) ||
                      (item.status !== 'Non Aktif' && route === 'keuangan')
                    ">
                      <a-button-group ghost>
                        <div class="margin-top">
                          <a-button :disabled="
                            item.cancelStatus && item.cancelStatus == 'Canceled'
                          ">
                            <router-link :to="{
                              name: editLink,
                              params: { id: item.id, type: 'revised' },
                            }">
                              <a-icon type="edit" />
                              <span>&nbsp;{{ editLink == 'editPo' ? 'Revise' : 'Edit Data' }}</span>
                            </router-link>
                          </a-button>
                          <a-button v-if="
                            !disabledCreateEditLink &&
                            !disabledCreateEditLink &&
                            (item.status === 'Revised' ||
                              (item.status !== 'Non Aktif' &&
                                route === 'keuangan')) &&
                            (!item.cancelStatus ||
                              (item.cancelStatus &&
                                item.cancelStatus !== 'Canceled')) &&
                            allowcancel
                          " @click="handleCancel(item)" :disabled="
  item.cancelStatus && item.cancelStatus == 'Canceled'
" :loading="load.cancel">
                            <router-link :to="{ name: '', params: { id: item.id } }">
                              <a-icon type="close-square" />&nbsp;
                              <span>Cancel</span>
                            </router-link>
                          </a-button>
                          <a-button v-if="rab" @click="handleRab(item)">
                            <span>RAB</span>
                          </a-button>
                        </div>
                      </a-button-group>
                    </template>
                  </div>
                  <div v-if="item.timeline" :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'">
                    <div class="m-display-flex flex-row space-between">
                      <h4 v-if="item.unread" class="margin-remove">
                        Workflow Status
                      </h4>
                      <span v-else class="margin-remove">Workflow Status</span>
                      <a-tag v-if="item.endStatus && item.endStatus === 'Closed'" color="grey" class="margin-remove"
                        :style="'width:50%;text-align: center'">CLOSED</a-tag>
                      <a-tag v-else-if="
                        item.endStatus && item.endStatus === 'Opened'
                      " color="blue" class="margin-remove" :style="'width:50%;text-align: center'">NOT CLOSED</a-tag>
                    </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item v-for="(timeline, index) in item.timeline" :key="index"
                        class="m-display-flex space-between flex-row nowrap">
                        <span class="margin-right">{{ timeline.actor }}</span>
                        <status :class="getScreen ? 'margin-remove' : ''" :status="timeline.status" />
                      </a-timeline-item>
                    </a-timeline>
                    <div class="file-status" v-if="item.row_extra">
                      <div class="list">
                        <slot :item="item" name="row_extra"></slot>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="item.rightStatusBesar" :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'">
                    <div class="m-display-flex flex-row space-between">
                      <h4 v-if="item.unread" class="margin-remove">
                        Status
                      </h4>
                      <div v-else class="margin-remove">Status</div>
                      <a-tag v-if="item.rightStatusBesar == 'Done'" color="blue" class="margin-remove"
                          :style="'width:50%;text-align: center'">DONE</a-tag>
                      <status v-else :status="item.rightStatusBesar" />
                    </div>
                  </div>
                </div>
              </a-list-item-meta>
            </router-link>
            <slot name="actions" :source="item"></slot>
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <a-tab-pane v-if="draftList" key="draft">
        <span slot="tab">
          {{ dataDraftTitle ? dataDraftTitle : 'Draft List' }}
          <a-badge class="m-badge m-badge-small" :count="draftList.length" :numberStyle="{ backgroundColor: 'red' }"
            v-if="draftList && draftList.length > 0">
          </a-badge>
        </span>
        <a-list itemLayout="vertical" :dataSource="draftList" :pagination="pagination">
          <Empty v-if="draftList ? draftList.length <= 0 : draftList" />
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta>
              <a-row slot="title" type="flex" justify="space-between">
                <div class="ant-card-head-title" style="padding:0px!important"><span>{{ item.title }}</span></div>
                <Status v-if="item.status" :status="item.status" class="margin-remove" />
              </a-row>
              <div slot="description">
                <ul class="m-list-wrapper">
                  <li v-for="item in item.subdesc" :key="item" class="margin-remove">
                    {{ item }}
                  </li>
                  <li v-if="price">
                    <h3 class="margin-remove">
                      {{ formatCurrency(item.mata_uang, item.price) }}
                    </h3>
                  </li>
                  <li v-if="estimasi">
                    <a-divider class="margin-small" />
                    <h4 class="margin-remove m-text-align right m-text-sub">
                      Estimated Value
                    </h4>
                    <h3 class="margin-remove m-text-align right">
                      {{ formatCurrency(item.mata_uang, item.estimated_value) }}
                    </h3>
                    <h3 class="margin-remove m-text-align right">
                      {{ formatCurrency(item.mata_uang, item.estimated_value) }}
                    </h3>
                  </li>
                  <li v-if="rating">
                    <Rating v-if="item.rating_value" :rating="item.rating_value" />
                  </li>
                </ul>
              </div>
            </a-list-item-meta>
            <template class="actions">
              <a-button-group ghost class="margin-top">
                <a-button v-if="!item.flagdisabledEdit && draftEditLink" type="default">
                  <router-link :to="{
                    name: draftEditLink,
                    params: { id: item.id, type: 'draft' },
                  }">
                    <a-icon type="edit" />&nbsp;Edit Data
                  </router-link>
                </a-button>
                <a-button v-if="!item.flagdisabledEdit && draftCreateLink" type="primary">
                  <router-link :to="{
                    name: draftCreateLink,
                    params: { id: item.id },
                  }">
                    <a-icon type="plus" />&nbsp;Create
                  </router-link>
                </a-button>
                <a-button v-if="!item.flagdisabledEdit && draftDeleteLink" type="danger" icon="close" @click="handleDeleteLink(item)" :loading="item.loading_delete">
                  Delete
                </a-button>
              </a-button-group>
            </template>
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <a-tab-pane v-if="otherList" :tab="otherListTitle ? otherListTitle : 'Report List'" key="other">
        <a-list itemLayout="vertical" :dataSource="otherList" :pagination="pagination">
          <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
          <a-list-item :class="item.unread ? '' : 'read'" slot="renderItem" slot-scope="item">
            <router-link :to="{
              name: manifestLink,
              params: {
                id: item.id,
                user_pembuat: item.user_pembuat,
                rabview: rab,
                tipe: item.tipe
              },
            }">
              <a-list-item-meta>
                <div slot="description" class="m-display-flex space-between">
                  <div :style="getScreen ? 'width:100%' : 'width:50%'">
                    <div>
                      <span v-if="
                        item.cancelStatus && item.cancelStatus === 'Canceled'
                      ">
                        <status :status="'Cancelled'" />
                      </span>
                      <span v-if="
                        item.delivered_po_wo &&
                        item.delivered_po_wo.toLowerCase() === 'done'
                      ">
                        <status :status="'Received'" />
                      </span>
                      <span v-if="
                        item.closed_po_wo &&
                        item.closed_po_wo.toLowerCase() === '1'
                      ">
                        <status :status="'CLOSED'" />
                      </span>
                    </div>
                    <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                      {{ item.title }}
                    </h4>
                    <span class="color-black" v-else>{{ item.title }}</span>
                    <span class="m-display-block">{{ item.subtitle }}</span>
                    <ul class="m-list-wrapper">
                      <li v-for="(items, index) in item.subdesc" :key="index" class="margin-remove">
                        <span v-if="!Array.isArray(items)">{{ items }}</span>
                        <div v-else v-for="(subItem, index) in items" :key="index">
                          <div class="m-display-flex flex-row space-between">
                            <h4 v-if="item.unread" class="margin-remove">
                              {{ subItem.label }}
                            </h4>
                            <span v-else class="m-display-block margin-remove">{{ subItem.label }}</span>
                            {{ subItem.value }}
                          </div>
                        </div>
                      </li>
                    </ul>
                    <template class="actions" v-if="
                      (!disabledCreateEditLink &&
                        item.status == 'Revised' &&
                        !item.hideedit) ||
                      (item.status !== 'Non Aktif' && route === 'keuangan')
                    ">
                      <a-button-group ghost>
                        <a-button :disabled="
                          item.cancelStatus && item.cancelStatus == 'Canceled'
                        ">
                          <router-link :to="{
                            name: editLink,
                            params: { id: item.id, type: 'revised' },
                          }">
                            <a-icon type="edit" />
                            <span>&nbsp;{{ editLink == 'editPo' ? 'Revise' : 'Edit Data' }}</span>
                          </router-link>
                        </a-button>
                        <a-button v-if="
                          !disabledCreateEditLink &&
                          !disabledCreateEditLink &&
                          (item.status === 'Revised' ||
                            (item.status !== 'Non Aktif' &&
                              route === 'keuangan')) &&
                          (!item.cancelStatus ||
                            (item.cancelStatus &&
                              item.cancelStatus !== 'Canceled')) &&
                          allowcancel
                        " @click="handleCancel(item)" :disabled="
  item.cancelStatus && item.cancelStatus == 'Canceled'
">
                          <router-link :to="{ name: '', params: { id: item.id } }">
                            <a-icon type="close-square" />&nbsp;
                            <span>Cancel</span>
                          </router-link>
                        </a-button>
                        <a-button v-if="rab" @click="handleRab(item)">
                          <span>RAB</span>
                        </a-button>
                      </a-button-group>
                    </template>
                  </div>
                  <div :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'">
                    <div v-if="item.status" class="m-display-flex flex-row space-between">
                      <h4 v-if="item.unread" class="margin-remove">
                        Workflow Status
                      </h4>
                      <span v-else class="margin-remove">Workflow Status</span>
                      <a-tag v-if="item.endStatus && item.endStatus === 'Closed'" color="grey" class="margin-remove"
                        :style="'width:50%;text-align: center'">CLOSED</a-tag>
                      <a-tag v-else-if="
                        item.endStatus && item.endStatus === 'Opened'
                      " color="blue" class="margin-remove" :style="'width:50%;text-align: center'">NOT CLOSED</a-tag>
                    </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item v-for="(timeline, index) in item.timeline" :key="index"
                        class="m-display-flex space-between flex-row nowrap">
                        <span class="margin-right">{{ timeline.actor }}</span>
                        <status :class="getScreen ? 'margin-remove' : ''" :status="timeline.status" />
                      </a-timeline-item>
                    </a-timeline>
                    <div class="file-status" v-if="item.fileStatus">
                      <div class="list">
                        <slot :item="item" name="status_file"></slot>
                      </div>
                    </div>
                  </div>
                </div>
              </a-list-item-meta>
            </router-link>
          </a-list-item>
        </a-list>
      </a-tab-pane>
    </a-tabs>
  </a-card>
  <a-card v-else-if="isMonitoring" :class="loading ? '' : 'm-card-list'" :loading="loading">
    <div slot="title">
      <span><a-icon type="pic-center" />&nbsp; {{ title }}</span>
    </div>
    <div slot="extra">
      <a-button @click="handleCreate" icon="plus" type="primary" v-if="!disabledCreateEditLink">
        Create
      </a-button>
      <slot name="slot_extra"></slot>
    </div>
    <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
      <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
      <a-list-item :class="item.unread ? '' : 'read'" slot="renderItem" slot-scope="item">
        <router-link :to="{
          name: manifestLink,
          params: {
            id: item.id,
            user_pembuat: item.user_pembuat,
            rabview: rab,
          },
        }">
          <a-list-item-meta>
            <div slot="description" class="m-display-flex space-between">
              <div :style="getScreen ? 'width:100%' : 'width:50%'">
                <div v-if="
                  item.cancelStatus == '1' || item.cancelStatus == 'Canceled'
                ">
                  <status :status="'Cancelled'" />
                </div>
                <div v-if="item.closeStatus == 'Close'">
                  <status :status="'Tutup'" />
                </div>
                <!-- <div
                  v-if="
                    item.receiveStatus &&
                    item.receiveStatus.toLowerCase() === 'done'
                  "
                >
                  <status :status="'Received'" />
                </div> -->
                <div v-if="item.endStatus">
                  <a-tag :color="item.endStatus === 'Opened' ? 'blue' : 'grey'">{{
                    item.endStatus == "Closed" ? "Closed" : "Not Closed"
                  }}</a-tag>
                </div>
                <span v-if="
                  item.delivered_po_wo &&
                  item.delivered_po_wo.toLowerCase() === 'done'
                ">
                  <status :status="'Received'" />
                </span>
                <span v-if="
                  item.delivered_po_wo &&
                  item.delivered_po_wo.toLowerCase() === 'process'
                ">
                  <status :status="'on delivery'" />
                </span>
                <span v-if="
                  item.closed_po_wo &&
                  item.closed_po_wo.toLowerCase() === '1'
                ">
                  <status :status="'CLOSED'" />
                </span>
                <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                  {{ item.title }}
                </h4>
                <span class="color-black" v-else>{{ item.title }}</span>
                <a-tooltip v-if="typeof item.subtitle === 'object'" class="m-tooltip-inner" placement="top"
                  :title="item.subtitle.deskripsi">
                  <span class="m-text-ellipse">{{
                    item.subtitle.deskripsi
                  }}</span>
                </a-tooltip>
                <span v-else class="m-display-block">{{ item.subtitle }}</span>
                <ul class="m-list-wrapper">
                  <li v-for="(items, index) in item.subdesc" :key="index" class="margin-remove">
                    <span v-if="!Array.isArray(items) && typeof items !== 'object'">{{ items }}</span>
                    <a-tooltip v-else-if="typeof items === 'object'" class="m-tooltip-inner" placement="top"
                      :title="items.deskripsi">
                      <span class="m-text-ellipse">{{ items.deskripsi }}</span>
                    </a-tooltip>
                    <div v-else v-for="(subItem, index) in items" :key="index">
                      <div class="m-display-flex flex-row space-between">
                        <h4 v-if="item.unread" class="margin-remove">
                          {{ subItem.label }}
                        </h4>
                        <span v-else class="m-display-block margin-remove">{{
                          subItem.label
                        }}</span>
                        {{ subItem.value }}
                      </div>
                    </div>

                    <template v-if="Array.isArray(items)">
                      <div v-for="(subItem, index) in items" :key="index">
                        <div class="m-display-flex flex-row space-between">
                          <h4 v-if="item.unread" class="margin-remove">
                            {{ subItem.label }}
                          </h4>
                          <span v-else class="m-display-block margin-remove">{{
                            subItem.label
                          }}</span>
                          {{ subItem.value }}
                        </div>
                      </div>
                    </template>
                  </li>
                </ul>
              </div>
              <div :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'">
                <div v-if="item.timeline" class="m-display-flex flex-row space-between">
                  <h4 v-if="item.unread" class="margin-remove">
                    Workflow Status
                  </h4>
                  <span v-else class="margin-remove">Workflow Status</span>
                </div>
                <a-timeline class="m-timeline-content margin-top">
                  <a-timeline-item v-for="(timeline, index) in item.timeline" :key="index" class="
                        m-display-flex
                        space-between
                        flex-row
                        nowrap
                        align-top
                      ">
                    <span class="margin-right">{{ timeline.actor }}</span>
                    <status :class="getScreen ? 'margin-remove' : ''" :status="timeline.status" />
                  </a-timeline-item>
                </a-timeline>

                <div v-if="item.status_keuangan" class="m-display-flex flex-row space-between">
                  <a-divider class="margin-small" />
                  <h4 v-if="item.unread" class="margin-remove">Keuangan</h4>
                  <span v-else class="margin-remove">Keuangan</span>

                  <span class="margin-remove">{{ item.status_keuangan }}</span>
                </div>

                <div v-if="item.status_direktorat" class="m-display-flex flex-row space-between">
                  <a-divider class="margin-small" />
                  <h4 v-if="item.unread" class="margin-remove">Directorate {{ item.status_direktorat.direktorat }}</h4>
                  <span v-else class="margin-remove">Directorate {{ item.status_direktorat.direktorat }}</span>

                  <span class="margin-remove">{{ item.status_direktorat.status }}</span>
                </div>

                <div class="m-display-flex flex-row space-between">
                  <slot name="info" :source="item"> </slot>
                </div>
              </div>
            </div>
          </a-list-item-meta>
        </router-link>
      </a-list-item>
    </a-list>
  </a-card>
  <a-card v-else-if="isMonitoringtabbed" :class="loading ? '' : 'm-card-list'" :loading="loading">
    <div slot="title">
      <a-icon type="pic-center" />
      <span>&nbsp; {{ title }}</span>
    </div>
    <div slot="extra">
      <a-button type="primary" @click="handleCreate" icon="plus" v-if="!notCreate && !disabledCreateEditLink">
        Create
      </a-button>
      <slot name="slot_extra"></slot>
    </div>
    <a-tabs defaultActiveKey="list" type="card" @change="callbackTab">
      <a-tab-pane v-if="dataList" :tab="dataListTitle ? dataListTitle : 'Report List'" key="list">
        <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
          <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
          <a-list-item :class="item.unread ? '' : 'read'" slot="renderItem" slot-scope="item">
            <router-link :to="{
              name: manifestLink,
              params: {
                id: item.id,
                user_pembuat: item.user_pembuat,
                rabview: rab,
              },
            }">
              <a-list-item-meta>
                <div slot="description" class="m-display-flex space-between">
                  <div :style="getScreen ? 'width:100%' : 'width:50%'">
                    <div v-if="
                      item.cancelStatus == '1' || item.cancelStatus == 'Canceled'
                    ">
                      <status :status="'Cancelled'" />
                    </div>
                    <div v-if="item.closeStatus == 'Close'">
                      <status :status="'Tutup'" />
                    </div>
                    <!-- <div
                v-if="
                  item.receiveStatus &&
                  item.receiveStatus.toLowerCase() === 'done'
                "
              >
                <status :status="'Received'" />
              </div> -->
                    <div>
                      <span v-if="item.endStatus">
                        <a-tag :color="item.endStatus === 'Opened' ? 'blue' : 'grey'">{{
                          item.endStatus == "Closed" ? "Closed" : "Not Closed"
                        }}</a-tag>
                      </span>
                    
                      <span v-if="
                        item.delivered_po_wo &&
                        item.delivered_po_wo.toLowerCase() === 'refunded'
                      ">
                        <status :status="'Refunded'" />
                      </span>
                      <span v-if="
                        item.delivered_po_wo &&
                        item.delivered_po_wo.toLowerCase() === 'done'
                      ">
                        <status :status="'Received'" />
                      </span>
                      <span v-if="
                        item.delivered_po_wo &&
                        item.delivered_po_wo.toLowerCase() === 'process'
                      ">
                        <status :status="'on delivery'" />
                      </span>
                      <span v-if="
                        item.closed_po_wo &&
                        item.closed_po_wo.toLowerCase() === '1'
                      ">
                        <status :status="'CLOSED'" />
                      </span>
                    </div>
                    <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                      {{ item.title }}
                    </h4>
                    <span class="color-black" v-else>{{ item.title }}</span>
                    <a-tooltip v-if="typeof item.subtitle === 'object'" class="m-tooltip-inner" placement="top"
                      :title="item.subtitle.deskripsi">
                      <span class="m-text-ellipse">{{
                        item.subtitle.deskripsi
                      }}</span>
                    </a-tooltip>
                    <span v-else class="m-display-block">{{ item.subtitle }}</span>
                    <ul class="m-list-wrapper">
                      <li v-for="(items, index) in item.subdesc" :key="index" class="margin-remove">
                        <span v-if="!Array.isArray(items) && typeof items !== 'object'">{{ items }}</span>
                        <a-tooltip v-else-if="typeof items === 'object'" class="m-tooltip-inner" placement="top"
                          :title="items.deskripsi">
                          <span class="m-text-ellipse">{{ items.deskripsi }}</span>
                        </a-tooltip>
                        <div v-else v-for="(subItem, index) in items" :key="index">
                          <div class="m-display-flex flex-row space-between">
                            <h4 v-if="item.unread" class="margin-remove">
                              {{ subItem.label }}
                            </h4>
                            <span v-else class="m-display-block margin-remove">{{
                              subItem.label
                            }}</span>
                            {{ subItem.value }}
                          </div>
                        </div>

                        <template v-if="Array.isArray(items)">
                          <div v-for="(subItem, index) in items" :key="index">
                            <div class="m-display-flex flex-row space-between">
                              <h4 v-if="item.unread" class="margin-remove">
                                {{ subItem.label }}
                              </h4>
                              <span v-else class="m-display-block margin-remove">{{
                                subItem.label
                              }}</span>
                              {{ subItem.value }}
                            </div>
                          </div>
                        </template>
                      </li>
                    </ul>
                  </div>
                  <div :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'">
                    <div v-if="item.timeline" class="m-display-flex flex-row space-between">
                      <h4 v-if="item.unread" class="margin-remove">
                        Workflow Status
                      </h4>
                      <span v-else class="margin-remove">Workflow Status</span>
                    </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item v-for="(timeline, index) in item.timeline" :key="index" class="
                        m-display-flex
                        space-between
                        flex-row
                        nowrap
                        align-top
                      ">
                        <span class="margin-right">{{ timeline.actor }}</span>
                        <status :class="getScreen ? 'margin-remove' : ''" :status="timeline.status" />
                      </a-timeline-item>
                    </a-timeline>

                    <div v-if="item.status_keuangan" class="m-display-flex flex-row space-between">
                      <a-divider class="margin-small" />
                      <h4 v-if="item.unread" class="margin-remove">Keuangan</h4>
                      <span v-else class="margin-remove">Keuangan</span>

                      <span class="margin-remove">{{ item.status_keuangan }}</span>
                    </div>

                    <div v-if="item.status_direktorat" class="m-display-flex flex-row space-between">
                      <a-divider class="margin-small" />
                      <h4 v-if="item.unread" class="margin-remove">Directorate {{ item.status_direktorat.direktorat }}</h4>
                      <span v-else class="margin-remove">Directorate {{ item.status_direktorat.direktorat }}</span>

                      <span class="margin-remove">{{ item.status_direktorat.status }}</span>
                    </div>

                    <div class="m-display-flex flex-row space-between">
                      <slot name="info" :source="item"> </slot>
                    </div>
                  </div>
                </div>
              </a-list-item-meta>
            </router-link>
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <a-tab-pane v-if="draftList" key="draft">
        <span slot="tab">
          {{ dataDraftTitle ? dataDraftTitle : 'Draft List' }}
          <a-badge class="m-badge m-badge-small" :count="draftList.length" :numberStyle="{ backgroundColor: 'red' }"
            v-if="draftList && draftList.length > 0">
          </a-badge>
        </span>
        <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
          <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
          <a-list-item :class="item.unread ? '' : 'read'" slot="renderItem" slot-scope="item">
            <router-link :to="{
              name: manifestLink,
              params: {
                id: item.id,
                user_pembuat: item.user_pembuat,
                rabview: rab,
              },
            }">
              <a-list-item-meta>
                <div slot="description" class="m-display-flex space-between">
                  <div :style="getScreen ? 'width:100%' : 'width:50%'">
                    <div v-if="
                      item.cancelStatus == '1' || item.cancelStatus == 'Canceled'
                    ">
                      <status :status="'Cancelled'" />
                    </div>
                    <div v-if="item.closeStatus == 'Close'">
                      <status :status="'Tutup'" />
                    </div>
                    <!-- <div
                v-if="
                  item.receiveStatus &&
                  item.receiveStatus.toLowerCase() === 'done'
                "
              >
                <status :status="'Received'" />
              </div> -->
                    <div v-if="item.endStatus">
                      <a-tag :color="item.endStatus === 'Opened' ? 'blue' : 'grey'">{{
                        item.endStatus == "Closed" ? "Closed" : "Not Closed"
                      }}</a-tag>
                    </div>
                    <span v-if="
                      item.delivered_po_wo &&
                      item.delivered_po_wo.toLowerCase() === 'done'
                    ">
                      <status :status="'Received'" />
                    </span>
                    <span v-if="
                      item.delivered_po_wo &&
                      item.delivered_po_wo.toLowerCase() === 'process'
                    ">
                      <status :status="'on delivery'" />
                    </span>
                    <span v-if="
                      item.closed_po_wo &&
                      item.closed_po_wo.toLowerCase() === '1'
                    ">
                      <status :status="'CLOSED'" />
                    </span>
                    <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                      {{ item.title }}
                    </h4>
                    <span class="color-black" v-else>{{ item.title }}</span>
                    <a-tooltip v-if="typeof item.subtitle === 'object'" class="m-tooltip-inner" placement="top"
                      :title="item.subtitle.deskripsi">
                      <span class="m-text-ellipse">{{
                        item.subtitle.deskripsi
                      }}</span>
                    </a-tooltip>
                    <span v-else class="m-display-block">{{ item.subtitle }}</span>
                    <ul class="m-list-wrapper">
                      <li v-for="(items, index) in item.subdesc" :key="index" class="margin-remove">
                        <span v-if="!Array.isArray(items) && typeof items !== 'object'">{{ items }}</span>
                        <a-tooltip v-else-if="typeof items === 'object'" class="m-tooltip-inner" placement="top"
                          :title="items.deskripsi">
                          <span class="m-text-ellipse">{{ items.deskripsi }}</span>
                        </a-tooltip>
                        <div v-else v-for="(subItem, index) in items" :key="index">
                          <div class="m-display-flex flex-row space-between">
                            <h4 v-if="item.unread" class="margin-remove">
                              {{ subItem.label }}
                            </h4>
                            <span v-else class="m-display-block margin-remove">{{
                              subItem.label
                            }}</span>
                            {{ subItem.value }}
                          </div>
                        </div>

                        <template v-if="Array.isArray(items)">
                          <div v-for="(subItem, index) in items" :key="index">
                            <div class="m-display-flex flex-row space-between">
                              <h4 v-if="item.unread" class="margin-remove">
                                {{ subItem.label }}
                              </h4>
                              <span v-else class="m-display-block margin-remove">{{
                                subItem.label
                              }}</span>
                              {{ subItem.value }}
                            </div>
                          </div>
                        </template>
                      </li>
                    </ul>
                  </div>
                  <div :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'">
                    <div v-if="item.timeline" class="m-display-flex flex-row space-between">
                      <h4 v-if="item.unread" class="margin-remove">
                        Workflow Status
                      </h4>
                      <span v-else class="margin-remove">Workflow Status</span>
                    </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item v-for="(timeline, index) in item.timeline" :key="index" class="
                        m-display-flex
                        space-between
                        flex-row
                        nowrap
                        align-top
                      ">
                        <span class="margin-right">{{ timeline.actor }}</span>
                        <status :class="getScreen ? 'margin-remove' : ''" :status="timeline.status" />
                      </a-timeline-item>
                    </a-timeline>

                    <div v-if="item.status_keuangan" class="m-display-flex flex-row space-between">
                      <a-divider class="margin-small" />
                      <h4 v-if="item.unread" class="margin-remove">Keuangan</h4>
                      <span v-else class="margin-remove">Keuangan</span>

                      <span class="margin-remove">{{ item.status_keuangan }}</span>
                    </div>

                    <div v-if="item.status_direktorat" class="m-display-flex flex-row space-between">
                      <a-divider class="margin-small" />
                      <h4 v-if="item.unread" class="margin-remove">Directorate {{ item.status_direktorat.direktorat }}</h4>
                      <span v-else class="margin-remove">Directorate {{ item.status_direktorat.direktorat }}</span>

                      <span class="margin-remove">{{ item.status_direktorat.status }}</span>
                    </div>

                    <div class="m-display-flex flex-row space-between">
                      <slot name="info" :source="item"> </slot>
                    </div>
                  </div>
                </div>
              </a-list-item-meta>
            </router-link>
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <a-tab-pane v-if="otherList" :tab="otherListTitle ? otherListTitle : 'Report List'" key="other">
        <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
          <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
          <a-list-item :class="item.unread ? '' : 'read'" slot="renderItem" slot-scope="item">
            <router-link :to="{
              name: manifestLink,
              params: {
                id: item.id,
                user_pembuat: item.user_pembuat,
                rabview: rab,
                tipe: item.tipe
              },
            }">
              <a-list-item-meta>
                <div slot="description" class="m-display-flex space-between">
                  <div :style="getScreen ? 'width:100%' : 'width:50%'">
                    <div v-if="
                      item.cancelStatus == '1' || item.cancelStatus == 'Canceled'
                    ">
                      <status :status="'Cancelled'" />
                    </div>
                    <div v-if="item.closeStatus == 'Close'">
                      <status :status="'Tutup'" />
                    </div>
                    <!-- <div
                v-if="
                  item.receiveStatus &&
                  item.receiveStatus.toLowerCase() === 'done'
                "
              >
                <status :status="'Received'" />
              </div> -->
                    <div v-if="item.endStatus">
                      <a-tag :color="item.endStatus === 'Opened' ? 'blue' : 'grey'">{{
                        item.endStatus == "Closed" ? "Closed" : "Not Closed"
                      }}</a-tag>
                    </div>
                    <span v-if="
                      item.delivered_po_wo &&
                      item.delivered_po_wo.toLowerCase() === 'done'
                    ">
                      <status :status="'Received'" />
                    </span>
                    <span v-if="
                      item.delivered_po_wo &&
                      item.delivered_po_wo.toLowerCase() === 'process'
                    ">
                      <status :status="'on delivery'" />
                    </span>
                    <span v-if="
                      item.closed_po_wo &&
                      item.closed_po_wo.toLowerCase() === '1'
                    ">
                      <status :status="'CLOSED'" />
                    </span>
                    <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                      {{ item.title }}
                    </h4>
                    <span class="color-black" v-else>{{ item.title }}</span>
                    <a-tooltip v-if="typeof item.subtitle === 'object'" class="m-tooltip-inner" placement="top"
                      :title="item.subtitle.deskripsi">
                      <span class="m-text-ellipse">{{
                        item.subtitle.deskripsi
                      }}</span>
                    </a-tooltip>
                    <span v-else class="m-display-block">{{ item.subtitle }}</span>
                    <ul class="m-list-wrapper">
                      <li v-for="(items, index) in item.subdesc" :key="index" class="margin-remove">
                        <span v-if="!Array.isArray(items) && typeof items !== 'object'">{{ items }}</span>
                        <a-tooltip v-else-if="typeof items === 'object'" class="m-tooltip-inner" placement="top"
                          :title="items.deskripsi">
                          <span class="m-text-ellipse">{{ items.deskripsi }}</span>
                        </a-tooltip>
                        <div v-else v-for="(subItem, index) in items" :key="index">
                          <div class="m-display-flex flex-row space-between">
                            <h4 v-if="item.unread" class="margin-remove">
                              {{ subItem.label }}
                            </h4>
                            <span v-else class="m-display-block margin-remove">{{
                              subItem.label
                            }}</span>
                            {{ subItem.value }}
                          </div>
                        </div>

                        <template v-if="Array.isArray(items)">
                          <div v-for="(subItem, index) in items" :key="index">
                            <div class="m-display-flex flex-row space-between">
                              <h4 v-if="item.unread" class="margin-remove">
                                {{ subItem.label }}
                              </h4>
                              <span v-else class="m-display-block margin-remove">{{
                                subItem.label
                              }}</span>
                              {{ subItem.value }}
                            </div>
                          </div>
                        </template>
                      </li>
                    </ul>
                  </div>
                  <div :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'">
                    <div v-if="item.timeline" class="m-display-flex flex-row space-between">
                      <h4 v-if="item.unread" class="margin-remove">
                        Workflow Status
                      </h4>
                      <span v-else class="margin-remove">Workflow Status</span>
                    </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item v-for="(timeline, index) in item.timeline" :key="index" class="
                        m-display-flex
                        space-between
                        flex-row
                        nowrap
                        align-top
                      ">
                        <span class="margin-right">{{ timeline.actor }}</span>
                        <status :class="getScreen ? 'margin-remove' : ''" :status="timeline.status" />
                      </a-timeline-item>
                    </a-timeline>

                    <div v-if="item.status_keuangan" class="m-display-flex flex-row space-between">
                      <a-divider class="margin-small" />
                      <h4 v-if="item.unread" class="margin-remove">Keuangan</h4>
                      <span v-else class="margin-remove">Keuangan</span>

                      <span class="margin-remove">{{ item.status_keuangan }}</span>
                    </div>

                    <div v-if="item.status_direktorat" class="m-display-flex flex-row space-between">
                      <a-divider class="margin-small" />
                      <h4 v-if="item.unread" class="margin-remove">Directorate {{ item.status_direktorat.direktorat }}</h4>
                      <span v-else class="margin-remove">Directorate {{ item.status_direktorat.direktorat }}</span>

                      <span class="margin-remove">{{ item.status_direktorat.status }}</span>
                    </div>

                    <div class="m-display-flex flex-row space-between">
                      <slot name="info" :source="item"> </slot>
                    </div>
                  </div>
                </div>
              </a-list-item-meta>
            </router-link>
          </a-list-item>
        </a-list>
      </a-tab-pane>
    </a-tabs>
  </a-card>

  <!-- tractional -->
  <a-card v-else-if="isTransactional" :class="loading ? '' : 'm-card-list'" :loading="loading">
    <div slot="title">
      <a-icon type="pic-center" />
      <span>&nbsp; {{ title }}</span>
    </div>
    <a-button icon="plus" @click="handleCreate" type="primary" slot="extra" v-if="!disabledCreateEditLink">
      Create
    </a-button>
    <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
      <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
      <a-list-item :class="item.unread ? '' : 'read'" slot="renderItem" slot-scope="item">
        <router-link :to="{
          name: manifestLink,
          params: {
            id: item.id,
            user_pembuat: item.user_pembuat,
            rabview: rab,
          },
          }">
          <a-list-item-meta>
            <div slot="description">
              <div v-if="item.showDataRight">
                <div class="m-display-flex space-between">
                  <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                    {{ item.title }}
                  </h4>
                  <span class="color-black" v-else>{{ item.title }} &nbsp;</span>
                  <status :status="item.status" />
                </div>
                <div>{{ item.title_desc }}</div>
              </div>
              <div class="m-display-flex space-between">
                <div :style="getScreen ? 'width:100%' : 'width:50%'">
                  <div>
                    <span v-if="
                      item.cancelStatus &&
                      item.cancelStatus === 'Canceled' &&
                      item.closeStatus !== 'Close' &&
                      !item.status_besar
                    ">
                      <status :status="'Cancelled'" />
                    </span>
                    <span v-if="
                      item.closeStatus &&
                      item.closeStatus === 'Close' &&
                      !item.status_besar
                    ">
                      <status :status="'Tutup'" />
                    </span>
                    <!-- <div
                      v-if="
                        item.receiveStatus &&
                        item.receiveStatus.toLowerCase() === 'done'
                      "
                    >
                      <status :status="'Received'" />
                    </div> -->
                    <span v-if="
                      item.delivered_po_wo &&
                      item.delivered_po_wo.toLowerCase() === 'done'
                    ">
                      <status :status="'Received'" />
                    </span>
                    <span v-if="
                      item.delivered_po_wo &&
                      item.delivered_po_wo.toLowerCase() === 'process'
                    ">
                      <status :status="'on delivery'" />
                    </span>
                    <span v-if="
                      item.closed_po_wo &&
                      item.closed_po_wo.toLowerCase() === '1'
                    ">
                      <status :status="'CLOSED'" />
                    </span>
                  </div>
                  <!-- <br /> -->
                  <div v-if="!item.showDataRight">
                    <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                      {{ item.title }}
                    </h4>
                    <span class="color-black" v-else>{{ item.title }} &nbsp;</span>
                  
                    <a-tooltip v-if="typeof item.subtitle === 'object'" class="m-tooltip-inner" placement="top"
                      :title="item.subtitle.deskripsi">
                      <span class="m-text-ellipse">{{
                        item.subtitle.deskripsi
                      }}</span>
                    </a-tooltip>
                    <span v-else class="m-display-block">{{
                      item.subtitle
                    }}</span>
                  </div>

                  <ul class="m-list-wrapper">
                    <li v-for="(items, index) in item.subdesc" :key="index" class="margin-remove">
                      <span v-if="
                        !Array.isArray(items) && typeof items !== 'object'
                      ">{{ items }}</span>
                      <a-tooltip v-else-if="typeof items === 'object'" class="m-tooltip-inner" placement="top"
                        :title="items.deskripsi">
                        <span class="m-text-ellipse">{{
                          items.deskripsi
                        }}</span>
                      </a-tooltip>
                      <div v-else v-for="(subItem, index) in items" :key="index">
                        <div class="m-display-flex flex-row space-between">
                          <h4 v-if="item.unread" class="margin-remove">
                            {{ subItem.label }}
                          </h4>
                          <h4 v-else class="m-display-block margin-remove">
                            {{ subItem.label }}
                          </h4>
                          {{ subItem.value }}
                        </div>
                      </div>
                      <template v-if="Array.isArray(items)">
                        <div v-for="(subItem, index) in items" :key="index">
                          <div class="m-display-flex flex-row space-between">
                            <h4 v-if="item.unread" class="margin-remove">
                              {{ subItem.label }}
                            </h4>
                            <h4 v-else class="m-display-block margin-remove">
                              {{ subItem.label }}
                            </h4>
                            {{ subItem.value }}
                          </div>
                        </div>
                      </template>
                    </li>
                  </ul>
                </div>
                <div :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'"
                  v-if="item.showDataRight">
                  <ul class="m-list-wrapper">
                    <li v-for="(items, index) in item.subdesc2" :key="index" class="margin-remove">
                      <span v-if="
                        !Array.isArray(items) && typeof items !== 'object'
                      ">{{ items }}</span>
                      <a-tooltip v-else-if="typeof items === 'object'" class="m-tooltip-inner" placement="top"
                        :title="items.deskripsi">
                        <span class="m-text-ellipse">{{
                          items.deskripsi
                        }}</span>
                      </a-tooltip>
                      <div v-else v-for="(subItem, index) in items" :key="index">
                        <div class="m-display-flex flex-row space-between">
                          <h4 v-if="item.unread" class="margin-remove">
                            {{ subItem.label }}
                          </h4>
                          <h4 v-else class="m-display-block margin-remove">
                            {{ subItem.label }}
                          </h4>
                          {{ subItem.value }}
                        </div>
                      </div>
                      <template v-if="Array.isArray(items)">
                        <div v-for="(subItem, index) in items" :key="index">
                          <div class="m-display-flex flex-row space-between">
                            <h4 v-if="item.unread" class="margin-remove">
                              {{ subItem.label }}
                            </h4>
                            <h4 v-else class="m-display-block margin-remove">
                              {{ subItem.label }}
                            </h4>
                            {{ subItem.value}}
                          </div>
                        </div>
                      </template>
                    </li>
                  </ul>
                </div>
                <div v-if="!item.timeline && item.status_besar">
                  <status :status="item.status_besar" />
                </div>
                <div :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'"
                  v-if="item.timeline">
                  <div class="m-display-flex flex-row space-between">
                    <h4 v-if="item.unread" class="margin-remove">
                      Workflow Status
                    </h4>
                    <span v-else class="margin-remove">Workflow Status</span>
                  </div>
                  <a-timeline class="m-timeline-content margin-top">
                    <a-timeline-item v-for="(timeline, index) in item.timeline" :key="index"
                      class="m-display-flex space-between flex-row nowrap">
                      <span class="margin-right">{{ timeline.actor }}</span>
                      <status :class="getScreen ? 'margin-remove' : ''" :status="timeline.status" />
                    </a-timeline-item>
                  </a-timeline>
                  <a-divider class="margin-small" />
                  <div v-if="item.status_keuangan" class="m-display-flex flex-row space-between">
                    <h4 v-if="item.unread" class="margin-remove">Keuangan</h4>
                    <span v-else class="margin-remove">Keuangan</span>

                    <span class="margin-remove">{{
                      item.status_keuangan
                    }}</span>
                  </div>
                  <div v-if="item.status_direktorat" class="m-display-flex flex-row space-between">
                    <h4 v-if="item.unread" class="margin-remove">Directorate {{ item.status_direktorat.direktorat }}</h4>
                    <span v-else class="margin-remove">Directorate {{ item.status_direktorat.direktorat }}</span>

                    <span class="margin-remove">{{
                      item.status_direktorat.status
                    }}</span>
                  </div>
                  <div v-if="item.is_uploaded" class="m-display-flex flex-row space-between">
                    <h4 v-if="item.unread" class="margin-remove">Document</h4>
                    <span v-else class="margin-remove">Document</span>

                    <a-tag v-if="item.is_uploaded == '1'" color="green" class="margin-remove"
                      style="'width:50%;text-align: center'">File Have Been Uploaded
                    </a-tag>
                    <a-tag v-else color="grey" class="margin-remove" style="'width:50%;text-align: center'">No File
                      Uploaded
                    </a-tag>
                  </div>
                </div>
                <div :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'"
                  v-if="item.onlyFileUploaded">
                  <div v-if="item.is_uploaded" class="m-display-flex flex-row space-between">
                    <h4 v-if="item.unread" class="margin-remove">Document</h4>
                    <span v-else class="margin-remove">Document</span>

                    <a-tag v-if="item.is_uploaded == '1'" color="green" class="margin-remove"
                      style="'width:50%;text-align: center'">File Have Been Uploaded
                    </a-tag>
                    <a-tag v-else color="grey" class="margin-remove" style="'width:50%;text-align: center'">No File
                      Uploaded
                    </a-tag>
                  </div>
                </div>
              </div>
              <slot name="actions" v-if="
                item.status == 'Revised' ||
                rab ||
                informasi ||
                item.islistPPrevised
              " class="m-card-list-actions">
                <a-button-group ghost>
                  <a-button v-if="
                    (!disabledCreateEditLink &&
                      ((!disabledCreateEditLink &&
                        item.status === 'Revised' && !item.dis_rev &&
                        item.closeStatus !== 'Close') ||
                        (!disabledCreateEditLink && route === 'keuangan')) &&
                      (!item.cancelStatus ||
                        (item.cancelStatus &&
                          item.cancelStatus !== 'Canceled'))) ||
                    item.islistPPrevised
                  ">
                    <router-link :to="{ name: editLink, params: { id: item.id } }">
                      <a-icon type="edit" />&nbsp; Revise
                    </router-link>
                  </a-button>
                  <a-button v-if="
                    !disabledCreateEditLink &&
                    ((!disabledCreateEditLink &&
                      item.cancelStatus !== 'Canceled' &&
                      item.cancelStatus !== 'Unusual') ||
                      (!disabledCreateEditLink && route === 'keuangan')) &&
                    (!item.canceled_Status ||
                      (item.canceled_Status &&
                        item.canceled_Status !== 'Canceled')) &&
                    allowcancel === true
                  " @click="handleCancel(item)">
                    <router-link :to="{ name: '', params: { id: item.id } }">
                      <a-icon type="close-square" />&nbsp;
                      <span>Cancel</span>
                    </router-link>
                  </a-button>
                  <a-button v-if="rab" @click="handleRab(item)">
                    <span>RAB</span>
                  </a-button>
                  <a-button v-if="informasi" @click="handleInfo(item)">
                    <span>Informasi</span>
                  </a-button>
                </a-button-group>
              </slot>
            </div>
          </a-list-item-meta>
        </router-link>
        <slot name="action-card" :item="item"></slot>
      </a-list-item>
    </a-list>
  </a-card>
  <a-card v-else-if="tabbedSimulasiAnggaran" :class="loading ? '' : 'm-card-list'" :loading="loading">
    <div slot="title">
      <a-icon type="pic-center" />
      <span>&nbsp; {{ title }}</span>
    </div>
    <a-button @click="handleCreate" icon="plus" type="primary" slot="extra" v-if="!disabledCreateEditLink">
      Create
    </a-button>
    <a-tabs defaultActiveKey="list" type="card" @change="callbackTab">
      <a-tab-pane tab="Simulation List" key="list">
        <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
          <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
          <a-list-item :class="item.unread ? '' : 'read'" slot="renderItem" slot-scope="item">
            <a-list-item-meta>
              <div slot="description" class="m-display-flex space-between">
                <div>
                  <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                    {{ item.title }}
                  </h4>
                  <span class="color-black" v-else>{{ item.title }}</span>
                </div>
                <div v-if="item.cancelStatus && item.cancelStatus === 'Canceled'">
                  <status :status="'Cancelled'" />
                </div>
                <div v-else>
                  <status :class="getScreen ? 'margin-remove' : ''" :status="item.status" />
                </div>
              </div>
              <div slot="description" class="m-display-flex space-between">
                <div>
                  <span class="m-display-block">{{ item.subtitle }}</span>
                  <br />
                </div>
                <div></div>
              </div>
              <div v-for="(items, index) in item.subdesc" :key="index" slot="description"
                class="m-display-flex flex-row space-between">
                <span>{{ items.label }}</span>
                <span>{{ items.value }}</span>
              </div>
            </a-list-item-meta>
            <div class="margin-top">
              <template class="actions">
                <a-button-group ghost>
                  <a-button type="primary">
                    <router-link :to="{
                      name: manifestLink,
                      params: { id: item.id, thn: item.thn },
                    }">
                      <a-icon type="eye" />&nbsp;Manifest
                    </router-link>
                  </a-button>
                  <a-button type="default">
                    <router-link :to="{
                      name: createLink,
                      params: { id_template: item.id, thn: item.thn },
                    }">
                      <a-icon type="plus" />&nbsp;Copy
                    </router-link>
                  </a-button>
                  <a-button v-if="
                    !disabledCreateEditLink &&
                    !disabledCreateEditLink &&
                    ((item.status === 'Revised' &&
                      item.cancelStatus == null) ||
                      (item.status !== 'Non Aktif' && route === 'keuangan'))
                  ">
                    <router-link :to="{
                      name: editLink,
                      params: { id: item.id, type: 'revised' },
                    }">
                      <a-icon type="edit" />
                      <span>&nbsp;Edit Data</span>
                    </router-link>
                  </a-button>
                </a-button-group>
              </template>
            </div>
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <a-tab-pane key="draft">
        <span slot="tab">
          Draft List
          <a-badge class="m-badge m-badge-small" :count="draftList.length" :numberStyle="{ backgroundColor: 'red' }"
            v-if="draftList && draftList.length > 0">
          </a-badge>
        </span>
        <a-list itemLayout="vertical" :dataSource="draftList" :pagination="pagination">
          <Empty v-if="draftList ? draftList.length <= 0 : draftList" />
          <a-list-item :class="item.unread ? '' : 'read'" slot="renderItem" slot-scope="item">
            <a-list-item-meta>
              <div slot="description" class="m-display-flex space-between">
                <div>
                  <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                    {{ item.title }}
                  </h4>
                  <span class="color-black" v-else>{{ item.title }}</span>
                </div>
                <div></div>
              </div>
              <div slot="description" class="m-display-flex space-between">
                <div>
                  <span class="m-display-block">{{ item.subtitle }}</span>
                  <br />
                </div>
                <div></div>
              </div>
              <div v-for="(items, index) in item.subdesc" :key="index" slot="description"
                class="m-display-flex flex-row space-between">
                <span>{{ items.label }}</span>
                <span>{{ items.value }}</span>
              </div>
            </a-list-item-meta>
            <div class="margin-top">
              <template class="actions">
                <a-button-group ghost>
                  <a-button>
                    <router-link :to="{
                      name: editLink,
                      params: { id: item.id, thn: item.thn },
                    }">
                      <a-icon type="edit" />
                      <span>&nbsp;Edit Data</span>
                    </router-link>
                  </a-button>
                  <a-button type="default">
                    <router-link :to="{
                      name: createLink,
                      params: { id_template: item.id, thn: item.thn },
                    }">
                      <a-icon type="plus" />&nbsp;Copy
                    </router-link>
                  </a-button>
                  <a-button type="danger" @click="handleDeleteDraftSimulasiAnggaran(item.id)">
                    <a-icon type="delete" />
                    <span>&nbsp;Delete Data</span>
                  </a-button>
                </a-button-group>
              </template>
            </div>
          </a-list-item>
        </a-list>
      </a-tab-pane>
    </a-tabs>
  </a-card>
  <a-card v-else-if="tabbedBudget" :class="loading ? '' : 'm-card-list'" :loading="loading">
    <div slot="title">
      <a-icon type="pic-center" />
      <span>&nbsp; {{ title }}</span>
    </div>
    <a-button type="primary" slot="extra" v-if="!disabledCreateEditLink" @click="handleCreate" icon="plus">
      Create
    </a-button>
    <a-tabs :defaultActiveKey="defaultTabActiveKey ? defaultTabActiveKey : 'list'" type="card" @change="callbackTab">
      <a-tab-pane tab="Budget List" key="list">
        <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
          <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
          <a-list-item :class="item.unread ? '' : 'read'" slot="renderItem" slot-scope="item">
            <router-link :to="{
              name: manifestLink,
              params: {
                id: item.id,
                user_pembuat: item.user_pembuat,
                rabview: rab,
                budget_thn: item.budget_thn,
                status: item.status_besar
              },
            }">
              <a-list-item-meta>
                <div slot="description" class="m-display-flex space-between">
                  <div :style="getScreen ? 'width:100%' : 'width:50%'">
                    <div v-if="
                      item.cancelStatus && item.cancelStatus === 'Canceled'
                    ">
                      <status :status="'Cancelled'" />
                    </div>
                    <h4 v-if="item.unread" class="m-list-title m-text-bold margin-remove">
                      {{ item.title }}
                    </h4>
                    <span class="color-black" v-else>{{ item.title }}</span>
                    <div class="margin-bottom" v-if="item.close_budget == 'Close'">
                      <status :status="'Tutup'" />
                    </div>
                    <div class="margin-bottom" v-else>
                      <status :status="item.close_budget" />
                    </div>
                    <span class="m-display-block">{{ item.subtitle }}</span>
                    <ul class="m-list-wrapper">
                      <li v-for="(items, index) in item.subdesc" :key="index" class="margin-remove">
                        <div>
                          <h4 class="margin-remove">{{ items.label }}</h4>
                          {{ items.value }}
                        </div>
                      </li>
                    </ul>
                    <template class="actions" v-if="
                      (!disabledCreateEditLink && item.status == 'Revised') ||
                      (item.status !== 'Non Aktif' && route === 'keuangan')
                    ">
                      <a-button-group ghost>
                        <a-button :disabled="
                          item.cancelStatus && item.cancelStatus == 'Canceled'
                        ">
                          <router-link :to="{
                            name: editLink,
                            params: { id: item.id, type: 'revised' },
                          }">
                            <a-icon type="edit" />
                            <span>&nbsp;Edit Data</span>
                          </router-link>
                        </a-button>
                        <a-button v-if="
                          !disabledCreateEditLink &&
                          !disabledCreateEditLink &&
                          (item.status === 'Revised' ||
                            (item.status !== 'Non Aktif' &&
                              route === 'keuangan')) &&
                          (!item.cancelStatus ||
                            (item.cancelStatus &&
                              item.cancelStatus !== 'Canceled')) &&
                          allowcancel
                        " @click="handleCancel(item)" :disabled="
                            item.cancelStatus && item.cancelStatus == 'Canceled'
                          ">
                          <router-link :to="{ name: '', params: { id: item.id } }">
                            <a-icon type="close-square" />&nbsp;
                            <span>Cancel</span>
                          </router-link>
                        </a-button>
                        <a-button v-if="rab" @click="handleRab(item)">
                          <span>RAB</span>
                        </a-button>
                      </a-button-group>
                    </template>
                  </div>
                  <div :class="getScreen ? 'margin-top' : ''" :style="getScreen ? 'width: 100%' : 'width:45%'">
                    <div class="m-display-flex flex-row space-between">
                      <h4 v-if="item.unread" class="margin-remove">
                        Workflow Status
                      </h4>
                      <span v-else class="margin-remove">Workflow Status</span>
                      <a-tag v-if="item.endStatus && item.endStatus === 'Closed'" color="grey" class="margin-remove"
                        :style="'width:50%;text-align: center'">CLOSED</a-tag>
                      <a-tag v-else-if="
                        item.endStatus && item.endStatus === 'Opened'
                      " color="blue" class="margin-remove" :style="'width:50%;text-align: center'">NOT CLOSED</a-tag>
                    </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item v-for="(timeline, index) in item.timeline" :key="index"
                        class="m-display-flex space-between flex-row nowrap">
                        <span class="margin-right">{{ timeline.actor }}</span>
                        <status :class="getScreen ? 'margin-remove' : ''" :status="timeline.status" />
                      </a-timeline-item>
                    </a-timeline>
                  </div>
                </div>
              </a-list-item-meta>
            </router-link>
            <!-- footer card -->
            <slot name="footer-card" :item="item"></slot>
            <!-- end footer -->
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <a-tab-pane key="draft" v-if="!disabledCreateEditLink">
        <span slot="tab">
          Draft List
          <a-badge class="m-badge m-badge-small" :count="draftList.length" :numberStyle="{ backgroundColor: 'red' }"
            v-if="draftList && draftList.length > 0">
          </a-badge>
        </span>
        <a-list itemLayout="vertical" :dataSource="draftList" :pagination="pagination">
          <Empty v-if="draftList ? draftList.length <= 0 : draftList" />
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta>
              <a-row slot="title" type="flex" justify="space-between">
                <a href="#">{{ item.title }}</a>
                <Status :status="item.status" class="margin-remove" />
              </a-row>
              <div slot="description">
                <ul class="m-list-wrapper">
                  <li v-for="(items, index) in item.subdesc" :key="index" class="margin-remove">
                    <div>
                      <h4 class="margin-remove">{{ items.label }}</h4>
                      {{ items.value }}
                    </div>
                  </li>
                </ul>
              </div>
            </a-list-item-meta>
            <template class="actions">
              <a-button-group ghost class="margin-top">
                <a-button type="default">
                  <router-link :to="{
                    name: draftEditLink,
                    params: { id: item.id, type: 'draft' },
                  }">
                    <a-icon :type="draftEditText ? 'eye' : 'edit'" />&nbsp;{{ draftEditText ? draftEditText : 'Edit Data'}}
                  </router-link>
                </a-button>
              </a-button-group>
            </template>
          </a-list-item>
        </a-list>
      </a-tab-pane>
    </a-tabs>
  </a-card>

  <a-card v-else-if="isCustom" :class="loading ? '' : 'm-card-list'" :loading="loading">
    <div slot="title">
      <a-icon type="pic-center" />
      <span>&nbsp; {{ title }}</span>
    </div>
  
    <a-button-group slot="extra">
      <slot name="extra"></slot>
    </a-button-group>

    <slot name="content" :items="dataList" :paginate="pagination"></slot>
  </a-card>
  
  <a-card :loading="loading" v-else>
    <div slot="title">
      <a-icon type="pic-center" />
      <span>&nbsp; {{ title }}</span>
    </div>
    <a-button-group slot="extra">
      <a-popover trigger="click" placement="bottom">
        <span slot="title">
          <span slot="title">Select Action</span>
        </span>
        <a-button icon="more" v-if="printlist"></a-button>
        <ul class="m-list-wrapper bordered" slot="content">
          <li>
            <a-tooltip class="m-tooltip-inner" placement="bottom" :title="printlist ? printlist.tooltips : ''">
              <a-button @click="handlePrintAvionik" icon="printer" type="default"
                v-if="printlist ? printlist.status : false" class="m-width-full" :loading="load.printAvionic">
                List Supplier Avionik
              </a-button>
            </a-tooltip>
          </li>
          <li>
            <a-tooltip class="m-tooltip-inner" placement="bottom" :title="printlist ? printlist.tooltips : ''">
              <a-button @click="handlePrint" icon="printer" type="default" v-if="printlist ? printlist.status : false"
                class="m-width-full" :loading="load.print">
                List Supplier Non Avionik
              </a-button>
            </a-tooltip>
          </li>
        </ul>
      </a-popover>
      <a-button @click="handleCreate" icon="plus" type="primary" v-if="!disabledCreateEditLink">
        Create
      </a-button>
    </a-button-group>

    <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
      <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
      <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta>
          <a-row slot="title" type="flex" justify="space-between">
            <div>
              <h4 class="margin-remove">{{ item.title }}</h4>
              <small>{{ item.subtitle }}</small>
            </div>
            <Status :status="item.status" :class="getScreen ? 'margin-remove' : 'margin-left'" />
          </a-row>
          <div slot="description" class="margin-top">
            <ul class="m-list-wrapper">
              <li v-for="(item, index) in item.subdesc" :key="index" class="margin-remove">
                <span v-if="!Array.isArray(item)">{{ item }}</span>
                <div v-else v-for="(subItem, index) in item" :key="index">
                  <h4 class="margin-remove">{{ subItem.label }}</h4>
                  {{ subItem.value }}
                </div>
              </li>

              <li v-if="price">
                <h3 class="margin-remove">
                  {{ formatCurrency(item.mata_uang, item.price) }}
                </h3>
              </li>
              <li v-if="estimasi">
                <h4 class="margin-remove m-text-align right m-text-sub">
                  Estimated Value
                </h4>
                <h3 class="margin-remove m-text-align right">
                  {{ formatCurrency(item.mata_uang, item.estimated_value) }}
                </h3>
              </li>
              <li v-if="sisaSaldo">
                <h4 class="margin-remove m-text-align right m-text-sub">
                  Sisa Saldo
                </h4>
                <h3 class="margin-remove m-text-align right">
                  {{ formatCurrency(item.mata_uang, item.sisa_saldo) }}
                </h3>
              </li>
              <li v-if="rating">
                <Rating :rating="item.rating_value" />
              </li>
            </ul>
          </div>
        </a-list-item-meta>
        <template class="actions">
          <template v-if="swapaction">
            <slot name="swapaction" :item="item"></slot>
          </template>
          <a-button-group ghost v-if="!swapaction">
            <a-button type="primary">
              <router-link :to="{
                name: manifestLink,
                params: {
                  id: item.id,
                  user_pembuat: item.user_pembuat,
                  rabview: rab,
                },
              }">
                <a-icon type="eye" />&nbsp;Manifest
              </router-link>
            </a-button>
            <a-button v-if="
              !disabledCreateEditLink &&
              ((!disabledCreateEditLink && item.status === 'Revised') ||
                (!disabledCreateEditLink && route === 'keuangan') ||
                (!disabledCreateEditLink && route === 'akuntansi'))
            ">
              <router-link :to="{ name: editLink, params: { id: item.id } }">
                <a-icon type="edit" />
                <span>&nbsp;Edit Data</span>
              </router-link>
            </a-button>
            <a-button v-else-if="
              !disabledCreateEditLink &&
              ((!disabledCreateEditLink &&
                item.status !== 'Revised' &&
                item.dataFor === 'supplier') ||
                (!disabledCreateEditLink && route === 'keuangan') ||
                (!disabledCreateEditLink && route === 'akuntansi'))
            ">
              <router-link :to="{
                name: editLink,
                params: { id: item.id, dataFor: 'supplier' },
              }">
                <a-icon type="edit" />
                <span>&nbsp;Edit Data</span>
              </router-link>
            </a-button>
            <a-button v-if="
              (item.status === 'Revised' ||
                (item.status !== 'Non Aktif' && route === 'keuangan')) &&
              (!item.cancelStatus ||
                (item.cancelStatus && item.cancelStatus !== 'Canceled')) &&
              allowcancel === true
            " @click="handleCancel(item)">
              <router-link :to="{ name: '', params: { id: item.id } }">
                <a-icon type="close-square" />&nbsp;
                <span>Cancel</span>
              </router-link>
            </a-button>
            <a-button v-if="rab" @click="handleRab(item)">
              <span>RAB</span>
            </a-button>
            <a-button v-if="informasi" @click="handleInfo(item)">
              <span>Informasi</span>
            </a-button>
          </a-button-group>
        </template>
      </a-list-item>
    </a-list>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Status from "@/components/Status.vue";
import Rating from "@/components/Rating.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";

export default {
  name: "DataList",
  components: {
    Status,
    Rating,
  },
  mixins: [CurrencyFormat],
  props: {
    title: String,
    createLink: String,
    dataList: {
      type: Array,
      required: true,
    },
    draftList: {
      type: Array,
    },
    otherList: {
      type: Array,
    },
    manifestLink: String,
    editLink: String,
    draftEditLink: String,
    draftCreateLink: String,
    estimasi: Boolean,
    sisaSaldo: Boolean,
    rating: Boolean,
    loading: Boolean,
    dateRange: Boolean,
    price: Boolean,
    tabbed: Boolean,
    tabbedTransactional: Boolean,
    rab: Boolean,
    route: String,
    disabledCreateEditLink: Boolean,
    allowcancel: Boolean,
    informasi: Boolean,
    isMonitoring: Boolean,
    isMonitoringtabbed: Boolean,
    isTransactional: Boolean,
    isCustom: Boolean,
    tabbedSimulasiAnggaran: Boolean,
    tabbedBudget: Boolean,
    swapaction: Boolean,
    dataListTitle: String,
    otherListTitle: String,
    dataDraftTitle: String,
    printlist: {
      type: Object,
    },
    notCreate: Boolean,
    draftDeleteLink: Boolean,
    draftEditText: String,
    defaultTabActiveKey: String,
  },
  data() {
    return {
      pagination: {
        pageSize: 5,
        size: "small",
      },
      load: {
        cancel: false,
        print: false,
        printAvionic: false,
      }
    };
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth"]),
  },
  methods: {
    handleRab(item) {
      Event.$emit("handleRab", item);
    },
    handleInfo(item) {
      Event.$emit("handleInfo", item);
    },
    handleCancel(item) {
      this.confirmMessageValue("confirm-cancel", item, null);
    },
    handleDeleteDraftSimulasiAnggaran(item) {
      this.confirmMessageValue("confirm-delete", item, null);
    },
    callbackTab(item) {
      Event.$emit("callbackTab", item);
    },
    handleCreate() {
      this.$router.push({ name: this.createLink });
    },
    handlePrintAvionik() {
      this.load.printAvionic = true;
      axios({
        method: "get",
        url: this.printlist.url,
        responseType: "blob",
        params: { kategori: "Avionik" },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.load.printAvionic = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.load.printAvionic = false;
          this.$router.go(-1);
        });
    },
    handlePrint() {
      this.load.print = true;
      axios({
        method: "get",
        url: this.printlist.url,
        responseType: "blob",
        params: { kategori: "Non Avionik" },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.load.print = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.load.print = false;
          this.$router.go(-1);
        });
    },
    setloadcancel(val) {
      this.load.cancel = val;
    },
    handleDeleteLink(item) {
      Event.$emit("emitDeleteLink", item);
    }
  },
  mounted() {
    Event.$on("loadDatalistcancel", this.setloadcancel);
  },
  beforeDestroy() {
    Event.$off("loadDatalistcancel", this.setloadcancel);
  },
};
</script>

<style lang="less">
.m-timeline {
  &-content {
    li {
      padding-bottom: @padding - 5;

      .ant-timeline-item-content {
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-between !important;
        width: 100% !important;
      }

      :last-child {
        min-height: 0 !important;
      }
    }
  }
}

.ant {
  &-list {
    &-item {
      padding: @padding - 5 0;

      &-meta {
        margin-bottom: 0;
      }
    }
  }
}
</style>